module.exports = __webpack_public_path__ + "static/media/20210401_203054_807_IMG_0024.3f605894.jpg";